// extracted by mini-css-extract-plugin
module.exports = {"logout":"LogoutAdmin_logout__11llW"};